import { transformMuiThemeToConcordeTheme } from '@epilot/concorde-elements'
import { useMemo } from 'react'

import { useAppStoreSelector } from '../../hooks/useAppStoreSelector'
import {
  selectIsRootLauncherJourney,
  selectOriginalJourneyOrRoot
} from '../../store/selectors/config'
import { selectDesignBuilderState } from '../../store/selectors/runtime'

import { transformJourneyTheme } from './utils'

export const useThemes = () => {
  const selectedOrRootJourney = useAppStoreSelector(selectOriginalJourneyOrRoot)
  const designInfo = useAppStoreSelector(selectDesignBuilderState)
  const isLauncher = useAppStoreSelector(selectIsRootLauncherJourney)

  if (!selectedOrRootJourney) {
    // mostly to coerce TS, should never happen
    throw new Error('No selected/root journey found')
  }

  return useMemo(() => {
    // If the preview theme is not present, design builder state is not active.
    // In this case, we ignore the design builder design tokens
    // Currently, launcher-type journeys are overriding designs and they shouldn't
    // TODO: cleanup for launcher-type journeys and remove special case
    const normalized =
      !isLauncher && designInfo ? designInfo : selectedOrRootJourney.design

    const concordeTheme = transformMuiThemeToConcordeTheme(
      transformJourneyTheme(normalized?.theme)
    )

    return { concordeTheme, designTokens: normalized?.designTokens }
  }, [designInfo, isLauncher, selectedOrRootJourney])
}
